import { readLegacyEnv } from './env';

export const FINIX_ENV = readLegacyEnv('VITE_FINIX_ENV', 'REACT_APP_FINIX_ENV', 'sandbox');
export const FINIX_APP_ID = readLegacyEnv(
  'VITE_FINIX_APP_ID',
  'REACT_APP_FINIX_APP_ID',
  'APrqMZhmwoRvLz4s63VSZKMP'
);
export const FINIX_MERCHANT_ID = readLegacyEnv(
  'VITE_FINIX_MERCHANT_ID',
  'REACT_APP_FINIX_MERCHANT_ID',
  'MUbSPQnj9dunLj1bsMKo7xz'
);
export const GOOGLE_MERCHANT_ID = readLegacyEnv(
  'VITE_GOOGLE_MERCHANT_ID',
  'REACT_APP_GOOGLE_MERCHANT_ID',
  'MU8tprFug37SUE9Ao9mz74NM'
);
export const GOOGLE_PAY_ENVIRONMENT = readLegacyEnv(
  'VITE_GOOGLE_PAY_ENVIRONMENT',
  'REACT_APP_GOOGLE_PAY_ENVIRONMENT',
  'TEST'
);
export const APPLE_MERCHANT_ID_FILE = readLegacyEnv(
  'VITE_APPLE_MERCHANT_ID_FILE',
  'REACT_APP_APPLE_MERCHANT_ID_FILE',
  'merchantid/dev-merchant-id-association.txt'
);
